module.exports = __webpack_public_path__ + "img/senalando-izqmx.0b11364b.png";